<template>
    <div class="meta-modal">
        <el-dialog
            :model-value="WebProfileStore.isEditMetaTitleModalOpen"
            width="700px"
            :show-close="false"
            class="custom-modal"
            @close="close"
            :title="$trans('web_profile.edit_meta_title') || 'Edit Meta Title'"
        >
            <span class="dialog-cancel-text" @click="close">
                {{ $trans("profile_dossier.cancel") }}
                <el-icon><Close /></el-icon>
            </span>
            <el-button
                type="primary"
                @click="save"
                :disabled="!isValidLength"
            >
                {{ $trans("web_profile.save") }}
            </el-button>

            <div class="table-container">
                <el-input
                    id="metaTitleInput"
                    v-model="localMetaTitle"
                    placeholder="Enter Meta Title"
                    type="textarea"
                    :rows="2"
                    maxlength="60"
                    resize="vertical"
                />
                <div class="char-counter">
                    <span>{{ localMetaTitle.length }}/60</span>&nbsp;
                    <span>{{ $trans("web_profile.characters_used") }}</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useWebProfileStore } from "@/stores/WebProfileStore";
import { Close } from "@element-plus/icons-vue";

export default {
    name: "EditMetaTitleModal",
    components: { Close },
    data() {
        return {
            localMetaTitle: "",
        };
    },
    computed: {
        ...mapStores(useWebProfileStore),
        isModalOpen() {
            return this.WebProfileStore.isEditMetaTitleModalOpen;
        },
        isValidLength() {
            return (
                this.localMetaTitle !== null &&
                this.localMetaTitle.length <= 60
            );
        },
    },
    watch: {
        isModalOpen(newValue) {
            if (newValue) {
                this.localMetaTitle = this.WebProfileStore.profile.meta_title || "";
            }
        },
    },
    methods: {
        close() {
            this.WebProfileStore.closeEditMetaTitleModal();
        },
        async save() {
            try {
                await this.WebProfileStore.updateMetaTitle(this.localMetaTitle);
                this.$message.success(this.$trans("web_profile.meta_title_saved") || "Meta title saved successfully");
            } catch (error) {
                console.error("Error saving meta title:", error);
                this.$message.error(this.$trans("global.something_went_wrong"));
            }
        },
    },
};
</script>

<style scoped>
.meta-modal :deep(.el-dialog) {
    --el-dialog-width: 700px;
    top: -100px !important;
}

:deep(.el-dialog__header) {
    padding-bottom: 40px;
}

.table-container {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 24px;
    padding-top: 10px;
    background-color: #ededed;
    font-family: "Barlow", sans-serif;
    padding-right: 25px;
}

:deep(.el-input) {
    width: 100%;
}

:deep(.el-input__wrapper.is-focus) {
    border: 2px solid #41abc4 !important;
    box-shadow: none !important;
}

.el-button {
    float: right;
    margin-top: -35px;
    background-color: #41abc4;
    border-color: #41abc4;
    border-radius: unset;
    width: 200px;
    font-size: 16px !important;
    font-weight: 700 !important;
}

.dialog-cancel-text {
    position: absolute;
    top: 5px;
    right: 21px;
    cursor: pointer;
    font-size: 14px;
    color: #909399;
    font-weight: 500;
    z-index: 2000;
    user-select: none;
}

.dialog-cancel-text:hover {
    color: #41abc4;
}

.dialog-cancel-text :deep(.el-icon) {
    top: 3px;
    transform: scale(1.4);
}

.char-counter {
    text-align: right;
    font-size: 16px !important;
    font-weight: 700 !important;
    color: #000 !important;
    margin-top: 8px;
}

:deep(.el-textarea__inner) {
    min-width: 100% !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    margin-top: 8px;
    min-height: 60px;
}
</style>